import React, { useEffect } from "react";
import { fetchMembershipPlans } from "../Redux/actions/membershipActions";
import { useDispatch, useSelector } from "react-redux";
import { APP_ROUTES } from "../PageRouting/pageRoutes";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";

const MembershipSlider = () => {
  const { memberShipPlans, isLoading } = useSelector(
    (state) => state.memberships
  );
  const sliderRef = React.useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchMembershipPlans({ status: 1 }));
  }, []);

  const settings2 = {
    dots: false,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    pauseOnHover: true,
    draggable: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <div className="sticky bg-white top-1">
      {/* Wrapper: relative so arrows can be absolutely positioned left/right */}
      <div className="relative flex items-center">

        {/* Left Arrow — pinned to the left edge, always vertically centered */}
        <button
          onClick={() => sliderRef.current.slickPrev()}
          className="absolute left-1 z-10 p-1 bg-gray-100 hover:bg-gray-200 rounded-md shadow-sm flex-shrink-0"
          style={{ top: "50%", transform: "translateY(-50%)" }}
        >
          <MdOutlineKeyboardArrowLeft size={20} className="text-gray-700" />
        </button>

        {/* Slider takes full width with padding to avoid overlap with arrows */}
        <div className="w-full px-9">
          <Slider ref={sliderRef} {...settings2}>
            {memberShipPlans.map((details, i) => (
              <div
                key={i}
                className="cursor-pointer"
                onClick={() => navigate(APP_ROUTES.JOINMEMBERSHIP)}
              >
                <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 px-2 py-4 text-center">
                  <span className="border-2 rounded-md text-base font-sans font-semibold border-[#81CAF4] w-30 sm:w-full text-center p-1 shadow-md">
                    {details?.description}
                  </span>
                  <span className="whitespace-nowrap">
                    <span className="text-sm">INR </span>
                    <strong>{details?.actualAmount}</strong>
                  </span>
                  <span className="text-sm text-center">{details?.upto_Discount_Percent}</span>
                  <strong className="underline text-primaryColor whitespace-nowrap">
                    View More
                  </strong>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        {/* Right Arrow — pinned to the right edge, always vertically centered */}
        <button
          onClick={() => sliderRef.current.slickNext()}
          className="absolute right-1 z-10 p-1 bg-gray-100 hover:bg-gray-200 rounded-md shadow-sm flex-shrink-0"
          style={{ top: "50%", transform: "translateY(-50%)" }}
        >
          <MdOutlineKeyboardArrowRight size={20} className="text-gray-700" />
        </button>

      </div>
    </div>
  );
};

export default MembershipSlider;
